export const addItemsToOrder = (items) => {
	if (!Array.isArray(items)) {
		console.error('Expected an array of items');
		return;
	}

	// Aggregate item quantities using a Map (O(n) complexity)
	const itemMap = items.reduce((map, { product }) => {
		if (!product?.itemCode) return map; // Guard clause for invalid structure
		map.set(product.itemCode, (map.get(product.itemCode) || 0) + 1);
		return map;
	}, new Map());

	// Convert map entries to an array of { itemCode, quantity } objects
	const caseItems = Array.from(itemMap, ([itemCode, quantity]) => ({
		itemCode,
		quantity,
	}));

	// Persist to sessionStorage safely
	try {
		sessionStorage.setItem('caseBuilderItems', JSON.stringify(caseItems));
	} catch (error) {
		console.error('Failed to save items to sessionStorage:', error);
	}
};

export const SortByItemCode = (items, type) => {
	if (type === 'main') {
		// Ensure we don't mutate the original array
		return [...items].sort((a, b) =>
			a.product.itemCode.localeCompare(b.product.itemCode, undefined, {
				numeric: true,
			})
		);
	} else if (type === 'swaps') {
		return items.map((swapGroup) => {
			// Only sort if swapGroup is an array, otherwise leave it as is
			if (Array.isArray(swapGroup)) {
				return [...swapGroup].sort((a, b) =>
					a.product.itemCode.localeCompare(b.product.itemCode, undefined, {
						numeric: true,
					})
				);
			}
			return swapGroup;
		});
	}
	return items;
};

export const CreateCaseArray = (items, multiplier) => {
	const finalArray = [];

	items.forEach((item) => {
		for (let i = 0; i < multiplier; i++) {
			finalArray.push(item);
		}
	});

	return finalArray;
};

// Fisher–Yates shuffle algorithm - shuffles an input array randomly.
export const shuffleArray = (array) => {
	const arr = [...array];
	for (let i = arr.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[arr[i], arr[j]] = [arr[j], arr[i]];
	}
	return arr;
};

// Create default swappables
export const createDefaultSwappables = (eligibleSwappables, caseUnique) => {
	// Shuffle the eligible swappables
	const shuffled = shuffleArray(eligibleSwappables);

	// Takes that shuffled list and divides it into “slots” (or groups) — each slot containing 3 items.
	return Array.from({ length: caseUnique }, (_, i) =>
		shuffled.slice(i * 3, i * 3 + 3)
	);
};

// Calculate pricing summary
export const calculateCasePrice = (items, contentfulFields) => {
	let totalPrice = 0;
	let listPrice = 0;
	let totalSavings = 0;

	let promoValue = contentfulFields?.promoValue || 0;
	let promoType = contentfulFields?.promoType || '';
	let promoTotal = 0;

	items.forEach((item) => {
		if (item.product.skus && item.product.skus.length > 0) {
			const sku = item.product.skus[0];
			listPrice += sku.listPrice || 0;
			totalPrice += sku.salePricePerBottle || sku.listPrice || 0;
		}
	});

	if (promoValue && promoType) {
		if (promoType?.toLowerCase() === 'dollar') {
			promoTotal = promoValue;
		} else if (promoType?.toLowerCase() === 'percentage') {
			promoTotal = (promoValue / 100) * totalPrice;
		}
		totalPrice -= promoTotal;
	}

	totalSavings = listPrice - totalPrice;

	return {
		listPrice: listPrice.toFixed(2),
		totalPrice: totalPrice.toFixed(2),
		totalSavings: totalSavings.toFixed(2),
	};
};
